var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFiltrosSce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-filtros-sce",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 40,
    viewBox: "0 0 49 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Block",
    fill: "none",
    stroke: "#1c1c1c",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 40,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 39,
    rx: 3.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "filtros",
    transform: "translate(13 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25",
    "data-name": "Rect\\xE1ngulo 25",
    width: 24,
    height: 24,
    fill: "#1c1c1c",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.957,16.669H.715a.715.715,0,1,1,0-1.429H12.962a2.615,2.615,0,0,1,5.034,0h1.291a.715.715,0,0,1,0,1.429h-1.3a2.614,2.614,0,0,1-5.033,0Zm1.328-.715a1.191,1.191,0,1,0,1.191-1.191A1.192,1.192,0,0,0,14.286,15.954ZM7.429,10H.715a.715.715,0,0,1,0-1.429H7.562a2.615,2.615,0,0,1,4.876,0h6.848a.715.715,0,0,1,0,1.429h-6.71a2.619,2.619,0,0,1-5.148,0Zm1.381-.476A1.191,1.191,0,1,0,10,8.335,1.191,1.191,0,0,0,8.809,9.526Zm-6.8-6.19H.715a.715.715,0,1,1,0-1.429h1.3a2.614,2.614,0,0,1,5.033,0H19.286a.715.715,0,0,1,0,1.429H7.038a2.614,2.614,0,0,1-5.033,0Zm1.328-.715A1.19,1.19,0,1,0,4.523,1.43,1.192,1.192,0,0,0,3.334,2.621Z",
    transform: "translate(2.188 2.712)",
    fill: "#1c1c1c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFiltrosSce);
export default __webpack_public_path__ + "static/media/icon-filtros-sce.7a21c2579ac12c9395cbd69c54aa4992.svg";
export { ForwardRef as ReactComponent };